/**
 * The permissions this portal asks about. Mirrors pkg/enums/Permission in the API —
 * what a person may do is a right on the account, never which portal they opened.
 *
 * Only the ones a screen here actually branches on are listed. A button that would
 * always come back 403 is hidden rather than shown and refused.
 */
export enum Permission {
    /**
     * Milo's door, and only his. What the assistant may READ through its tools is
     * still every tool's own permission check — this one says the person may open the
     * conversation at all. In this portal it is never enough on its own: the drawer
     * also asks for HousekeepingInspect, because Milo here is the supervisor's tool
     * and a housekeeper with a trolley has nothing to ask it that her round does not
     * already say (libs/assistant.ts, docs/AI.md § "Milo v portalu sobaric").
     */
    ChatUse             = 'chat:use',
    HousekeepingRead    = 'housekeeping:read',
    HousekeepingWork    = 'housekeeping:work',
    HousekeepingInspect = 'housekeeping:inspect',
    FacilityWork        = 'facility:work',
    MaintenanceRead     = 'maintenance:read',
    MaintenanceReport   = 'maintenance:report',
    MaintenanceWork     = 'maintenance:work',
    PropertyRead        = 'property:read',
    UserRead            = 'user:read',
}
